import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDokumen = 'master-dokumen-pendukung';
const postDokumenUrl = 'master-dokumen-pendukung';
const putDokumen = 'master-dokumen-pendukung';
const deleteDokumen = 'master-dokumen-pendukung/';

const getAllDokumenForDokumenPendukung = 'master-dokumen-pendukung-keanggotaan'
const getAllDokumenForDokumenRekomendasi = 'master-dokumen-pendukung-rekomendasi/'
const getAllDokumenForDokumenAseanCpa = 'master-dokumen-pendukung-asean-cpa'
const getAllDokumenForDokumenAnggotaUmum = 'master-dokumen-pendukung-anggota-umum'

class DokumenService {

    postDokumen(formData) {
        var headers = authHeader();
        var form = new FormData();
        form.append("kodeDokumen", formData.kodeDokumen);
        form.append("namaDokumen", formData.namaDokumen);

        if (typeof formData.contohDokumen !== 'undefined') {
            form.append('contohDokumen', formData.contohDokumen);
        }
        return axios
            .post(API_URL + postDokumenUrl, form, {
                headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
            })
            .then(response => {

                return response.data.message;
            });
    }

    putDokumen(formData) {
        var headers = authHeader();
        var form = new FormData();
        form.append("kodeDokumen", formData.kodeDokumen);
        form.append("namaDokumen", formData.namaDokumen);
        form.append("idMasterDokumen",formData.idMasterDokumen);
        form.append('statusRequired', formData.statusRequired); 
        if (typeof formData.contohDokumen !== 'undefined') {
            form.append('contohDokumen', formData.contohDokumen);
        }        

        return axios
            .put(
                API_URL + putDokumen , form,
                { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() } }
            );
    }

    deleteDokumen(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDokumen + formData.idMasterDokumen,
                { headers: authHeader() }
            );
    }
    getAllDokumenForDokumenPendukung() {
        return axios.get(
        API_URL + getAllDokumenForDokumenPendukung,
        {
            headers: authHeader()
        });
    }

    getAllDokumenForDokumenRekomendasi(id_rekomendasi) {
        return axios.get(
        API_URL + getAllDokumenForDokumenRekomendasi+id_rekomendasi,
        {
            headers: authHeader()
        });
    }
    getAllDokumenForDokumenAseanCpa() {
        return axios.get(
        API_URL + getAllDokumenForDokumenAseanCpa,
        {
            headers: authHeader()
        });
    }
    getAllDokumenForDokumenAnggotaUmum() {
        return axios.get(
        API_URL + getAllDokumenForDokumenAnggotaUmum,
        {
            headers: authHeader()
        });
    }

    getDokumen(currentPage, pageSize, filter) {

        return axios.get(
            API_URL + getDokumen + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    

}

export default new DokumenService();